import { CampaignAttachmentsController } from './campaign-attachments.controller'

function campaignAttachments () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-attachments/campaign-attachments.html?$$REVISION$$',
    controller: CampaignAttachmentsController
  }
}

export { campaignAttachments }
